import { Injectable, inject } from "@angular/core";
import { ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";

import { EMPTY, Observable, of } from "rxjs";
import { select, Store } from "@ngrx/store";
import { catchError, switchMap, take, tap } from "rxjs/operators";

import { LoadPatients, selectPatients } from "../store";
import { AppState } from "libs/tm-common/src/lib/store/reducers/reducers";
import { PatientModel } from "libs/tm-common/src/lib/models/patient.model";
import { NotificationService } from "libs/tm-common/src/lib/services/notification.lib.service";
import { PatientsService } from "./patients.lib.service";

@Injectable({
	providedIn: 'root'
})
export class PatientsResolver {
	private notificationService = inject(NotificationService);
	private patientsService = inject(PatientsService);
	private store = inject<Store<AppState>>(Store);


	resolve(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<PatientModel[]> {
		return this.store.pipe(
			select(selectPatients),
			take(1),
			switchMap((patients: PatientModel[]) => {
				if (patients?.length === 0) {
					return this.patientsService.getPatients().pipe(
						take(1),
						tap((patients: PatientModel[]) =>
							this.store.dispatch(new LoadPatients({ patients: patients }))
						)
					);
				}
				return of(patients);
			}),
			catchError(() => {
				this.notificationService.showErrorMessage("ResolvePatientsError", "", 5000);
				return EMPTY;
			})
		);
	}
}
